import { injectable } from 'inversify';
import { INotificationItem } from '../../../interfaces';
import { INotificationsPoolService } from './notifications-pool.interface';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class NotificationsPoolMock implements INotificationsPoolService {

    notificationsPoolObservable = (): Observable<Array<INotificationItem>> => NEVER;
}
